/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/comps/h5/Search/constants/mall-condition.ts
 * @Description:
 */
export const SORT_OPTS = [
  { text: '综合由低到高', value: 'totalScore:1' },
  { text: '综合由高到低', value: 'totalScore:2' },
  { text: '销量由低到高', value: 'sellCount:1' },
  { text: '销量由高到低', value: 'sellCount:2' },
  { text: '评分由低到高', value: 'shopScore:1' },
  { text: '评分由高到低', value: 'shopScore:2' },
];

// 商品搜索类型  0默认 1按交易规则 2 按合同
export const SEARCH_TYPE = {
  DEFAULT: 0,
  AGREEMENT: 1,
  CONTRACT: 2,
};

export const SEARCH_TYPE_OBJ = {
  name: '按交易规则',
  values: [
    { active: false, name: '交易规则', value: SEARCH_TYPE.AGREEMENT },
  ],
};
